import i18n from "i18next";

export function formatDateByLanguage(date: string | Date): string {
  const language = i18n.language || "en";

  // Mapeamento dos códigos de idioma para códigos de localização
  const localeMap: { [key: string]: string } = {
    ptBr: "pt-BR",
    pt: "pt-PT",
    en: "en-US",
    es: "es-ES",
    fr: "fr-FR",
    de: "de-DE",
  };

  const locale = localeMap[language] || "en-US";

  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(date));
}
